import React, { useRef, useEffect } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const Parking = props => {
    return (
        <FormControlLabel
            control={
                <>
                <img className='parking' src={require('../../../assets/icons/lane_config/parking.svg')} />
                <Checkbox
                    checked={props.checked}
                    onChange={(e) => props.handleSetParking(e.target.checked, props.dir)}
                    name="checkedB"
                    color="primary"
                    disabled={props.readOnly?true:false}
                />
                </>
            }
            label=""
        />
      )
}
export default Parking;